{
  "pages": {
    "listTitle": "Công việc",
    "addTitle": "Thêm công việc",
    "editTitle": "Sửa công việc",
    "detailsTitle": "Chi tiết công việc",
    "permissionDenied": "Bạn không có quyền xem công việc.",
    "createPermissionDenied": "Bạn không có quyền tạo công việc.",
    "editPermissionDenied": "Bạn không có quyền sửa công việc."
  },
  "status": {
    "todo": "Chưa làm",
    "in_progress": "Đang làm",
    "done": "Hoàn thành",
    "cancelled": "Đã hủy"
  },
  "priority": {
    "low": "Thấp",
    "medium": "Trung bình",
    "high": "Cao"
  },
  "fields": {
    "title": "Tiêu đề",
    "description": "Mô tả",
    "status": "Trạng thái",
    "priority": "Độ ưu tiên",
    "assignee": "Người phụ trách",
    "dueDate": "Hạn",
    "startDate": "Ngày bắt đầu",
    "timeRange": "Thời gian",
    "clinic": "Chi nhánh",
    "checklist": "Checklist",
    "createdBy": "Người tạo",
    "createdAt": "Ngày tạo",
    "assigneeInput": "Người nhận",
    "dueDateFull": "Hạn hoàn thành",
    "clinicOptional": "Chi nhánh (tuỳ chọn)",
    "project": "Dự án",
    "projectHint": "Để trống sẽ vào Việc lẻ",
    "information": "Thông tin",
    "relatedEntity": "Liên quan",
    "relatedLead": "Gắn với lead",
    "relatedPatient": "Gắn với bệnh nhân",
    "relatedLabOrder": "Gắn với đơn lab",
    "relatedTypes": {
      "lead": "Lead",
      "patient": "Bệnh nhân",
      "lab_order": "Đơn lab"
    },
    "source": "Nguồn",
    "openChatSource": "Mở tin gốc"
  },
  "placeholders": {
    "project": "Chọn dự án",
    "assignee": "Chọn người nhận",
    "clinic": "Chọn chi nhánh",
    "related": "Chọn lead, bệnh nhân hoặc đơn lab",
    "relatedLead": "Tìm lead",
    "relatedPatient": "Tìm bệnh nhân",
    "relatedLabOrder": "Tìm mã đơn lab",
    "relatedTypeMore": "Nhập ít nhất 2 ký tự",
    "relatedNoResults": "Không tìm thấy"
  },
  "table": {
    "title": "Tiêu đề",
    "project": "Dự án",
    "assignee": "Phụ trách",
    "priority": "Ưu tiên",
    "status": "Trạng thái",
    "dueDate": "Hạn",
    "actions": "Thao tác",
    "checklist": "Checklist"
  },
  "actions": {
    "add": "Thêm công việc",
    "edit": "Sửa",
    "delete": "Xóa",
    "view": "Xem",
    "save": "Lưu",
    "cancel": "Hủy",
    "refresh": "Làm mới",
    "addChecklistItem": "Thêm mục",
    "moveUp": "Lên",
    "moveDown": "Xuống",
    "removeItem": "Xóa mục"
    ,"create": "Tạo việc"
  },
  "filters": {
    "status": "Trạng thái",
    "priority": "Độ ưu tiên",
    "assignee": "Người phụ trách",
    "project": "Dự án",
    "search": "Tìm công việc",
    "allStatuses": "Tất cả trạng thái",
    "allPriorities": "Tất cả mức ưu tiên",
    "trigger": "Bộ lọc",
    "title": "Lọc công việc",
    "reset": "Xóa lọc",
    "apply": "Áp dụng",
    "all": "Tất cả",
    "none": "Không chọn",
    "selectStatus": "Chọn trạng thái",
    "selectPriority": "Chọn độ ưu tiên",
    "selectProject": "Chọn dự án",
    "selectAssignee": "Chọn người nhận",
    "selectClinic": "Chọn chi nhánh",
    "allAssignees": "Tất cả người nhận",
    "allClinics": "Tất cả chi nhánh",
    "allProjects": "Tất cả dự án",
    "ownership": "Phạm vi công việc",
    "ownershipAll": "Tất cả",
    "ownershipMine": "Gán tôi",
    "ownershipCreated": "Tôi tạo",
    "dueSection": "Hạn công việc",
    "dueRangePlaceholder": "Chọn khoảng ngày",
    "dueFocus": {
      "overdue": "Quá hạn",
      "dueSoon": "Sắp đến hạn"
    }
  },
  "tabs": {
    "all": "Tất cả",
    "mine": "Việc của tôi",
    "todo": "Chưa làm",
    "inProgress": "Đang làm",
    "done": "Hoàn thành"
  },
  "sidebar": {
    "myTasks": "Việc của tôi",
    "createdByMe": "Tôi tạo",
    "allProjects": "Tất cả dự án",
    "favorites": "Yêu thích",
    "projects": "Dự án",
    "status": "Trạng thái",
    "expandStatus": "Mở danh sách trạng thái",
    "collapseStatus": "Thu gọn danh sách trạng thái",
    "emptyProjects": "Chưa có dự án nào",
    "emptyFavorites": "Chưa có dự án yêu thích",
    "manageProjects": "Quản lý dự án",
    "expandProjects": "Mở danh sách dự án",
    "collapseProjects": "Thu gọn danh sách dự án",
    "expandFavorites": "Mở danh sách yêu thích",
    "collapseFavorites": "Thu gọn danh sách yêu thích",
    "addFavorite": "Thêm vào yêu thích",
    "removeFavorite": "Bỏ yêu thích",
    "clearFavorites": "Xóa tất cả yêu thích",
    "favoriteFailed": "Không thể cập nhật yêu thích",
    "newTask": "Tạo mới"
  },
  "views": {
    "label": "Chế độ xem công việc",
    "list": "Danh sách",
    "kanban": "Kanban",
    "calendar": "Lịch"
  },
  "groupBy": {
    "label": "Nhóm theo",
    "trigger": "Nhóm: {{value}}",
    "menuTitle": "Nhóm công việc theo",
    "status": "Trạng thái",
    "priority": "Mức độ ưu tiên",
    "assignee": "Người nhận",
    "dueDate": "Hạn công việc"
  },
  "dueBuckets": {
    "overdue": "Quá hạn",
    "today": "Hôm nay",
    "thisWeek": "Tuần này",
    "later": "Sau",
    "noDue": "Không có hạn"
  },
  "groups": {
    "expand": "Mở nhóm {{label}}",
    "collapse": "Thu gọn nhóm {{label}}",
    "empty": "Không có công việc {{label}}",
    "emptyTitle": "Chưa có công việc",
    "emptyDescription": "Hiện tại chưa có công việc nào trong nhóm {{label}}.",
    "loadMore": "Xem thêm {{count}} công việc",
    "loadMoreAll": "Xem thêm công việc"
  },
  "drawer": {
    "markComplete": "Đánh dấu hoàn thành",
    "markIncomplete": "Đánh dấu chưa hoàn thành",
    "titlePlaceholder": "Nhập tên công việc",
    "descriptionPlaceholder": "Ví dụ: Gọi lại khách sau khi gửi báo giá",
    "projects": "Dự án",
    "subtasks": "Subtask",
    "subtaskColumnName": "Tên subtask",
    "addSubtask": "Thêm subtask",
    "createSubmit": "Tạo",
    "creating": "Đang tạo...",
    "createTitle": "Tạo mới công việc",
    "discardCreateConfirm": "Bạn có thay đổi chưa lưu. Đóng và hủy tạo việc?",
    "attachments": "Đính kèm"
  },
  "discussion": {
    "comments": "Bình luận",
    "allActivity": "Hoạt động",
    "sortOldest": "Cũ nhất",
    "sortNewest": "Mới nhất",
    "emptyComments": "Chưa có bình luận nào",
    "emptyActivity": "Chưa có hoạt động nào",
    "loadMore": "Xem thêm",
    "composerPlaceholder": "Thêm bình luận… Gõ @ để nhắc đồng nghiệp"
  },
  "kanban": {
    "emptyColumn": "Không có công việc",
    "addTask": "Thêm công việc",
    "truncated": "Đang hiển thị {{shown}}/{{total}} công việc"
  },
  "calendar": {
    "prevMonth": "Tháng trước",
    "nextMonth": "Tháng sau",
    "more": "+{{count}} nữa",
    "addTask": "Thêm công việc",
    "weekdays": {
      "mon": "Thứ 2",
      "tue": "Thứ 3",
      "wed": "Thứ 4",
      "thu": "Thứ 5",
      "fri": "Thứ 6",
      "sat": "Thứ 7",
      "sun": "Chủ nhật"
    }
  },
  "empty": "Không tìm thấy công việc",
  "dialogs": {
    "deleteConfirm": "Bạn có chắc muốn xóa công việc này?",
    "deleteNamedConfirm": "Xóa công việc \"{{title}}\"?"
  },
  "validation": {
    "titleRequired": "Vui lòng nhập tiêu đề",
    "assigneeRequired": "Vui lòng chọn người nhận",
    "startAfterDue": "Ngày bắt đầu không được sau hạn hoàn thành"
  },
  "checklist": {
    "placeholder": "Bước {{number}}",
    "example": "Ví dụ: Gọi điện xác nhận lịch",
    "empty": "Chưa có bước nào. Thêm bước để theo dõi tiến độ.",
    "detailsEmpty": "Chưa có bước nào",
    "add": "Thêm bước"
  },
  "toasts": {
    "loadFailed": "Không tải được danh sách công việc",
    "created": "Đã tạo công việc",
    "createFailed": "Tạo công việc thất bại",
    "updated": "Đã cập nhật công việc",
    "updateFailed": "Cập nhật thất bại",
    "deleted": "Đã xóa công việc",
    "deleteFailed": "Xóa thất bại"
    ,"saveFailed": "Lưu công việc thất bại",
    "loadOneFailed": "Không tải được công việc",
    "createSuccess": "Tạo công việc thành công",
    "updateSuccess": "Cập nhật công việc thành công",
    "statusUpdated": "Đã cập nhật trạng thái",
    "statusUpdateFailed": "Không cập nhật được trạng thái",
    "invalidStatusTransition": "Không thể chuyển trạng thái này",
    "checklistUpdateFailed": "Không cập nhật được checklist"
  },
  "misc": {
    "notAvailable": "—",
    "notFound": "Không tìm thấy công việc.",
    "emptyList": "Không có công việc nào",
    "searchPlaceholder": "Tìm theo tiêu đề..."
  },
  "aria": {
    "viewDetails": "Chi tiết",
    "editTitle": "Sửa tiêu đề"
  }
}
